import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path d=\"M1.87578 0.696732L6.00057 4.82152L10.1254 0.696732L11.3039 1.87524L7.17908 6.00003L11.3039 10.1248L10.1254 11.3033L6.00057 7.17854L1.87578 11.3033L0.697266 10.1248L4.82205 6.00003L0.697266 1.87524L1.87578 0.696732Z\" fill=\"black\" fill-opacity=\"0.9\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol